import React, { useEffect } from 'react';
import StepperHeading from '../StepperHeading';
import { Box, Card, Grid, InputLabel, Stack, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { IoIosCheckmarkCircle, IoIosCloseCircle } from 'react-icons/io';
import { AppColors } from '../../../../Utils/helper/AppColors';
import CultService from '../../../../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../../../Utils/helper/HelperTexts';

const TYPE_TO_LABEL = {
	1: 'Daily',
	7: 'Weekly',
	14: 'Bi-Weekly',
	30: 'Monthly',
	0: 'Custom Date Range',
};

export default function CampaignPreview({ details, viewOnly, assistants }) {
	const [assistantsInfo, setAssistantsInfo] = React.useState({});


	const getModels = async () => {
		try {
			// if assistants we getting
			if (assistants?.length) {
				setAssistantsInfo(assistants.filter((o) => o?.id === details?.assistantId)[0]);
				return;
			}

			let res = await CultService.getModelAssistanst({
				params: {
					companyId: details?.company,
					// assistantId: details?.assistantId
				},
			});
			if (res.status == 200) {
				Array.isArray(res?.data?.data) && setAssistantsInfo(res?.data?.data.filter((o) => o?.id === details?.assistantId)[0]);
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
		}
	};

	useEffect(() => {
		if (details?.assistantId) getModels();
	}, [details]);
	return (
		<Box sx={(theme) => ({ borderRadius: '0 0 12px 12px', backgroundColor: theme.palette.primary.lightest_shade })}>
			{/* {!viewOnly && <StepperHeading title="Campaign Preview" subTitle="Please preview the campaign before publishing" />} */}
			<Card sx={{ overflowY: 'scroll', border: 'none', borderRadius: '0 0 12px 12px', height: 'calc(100vh - 140px)' }}>
				<Grid sx={{ '& .MuiStack-root': { gap: 0.5, maxWidth: 'fit-content' } }} container spacing={4}>
					<Grid item xs={6} sx={{ height: '120px' }}>
						<Stack sx>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Name
								{/* <span style={{ color: 'red' }}>*</span> */}
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
									wordBreak: 'break-word',
								}}
							>
								{details?.basicDetails?.name || '--'}
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={6} sx={{ height: '120px' }}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Description
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
									wordBreak: 'break-word',
								}}
							>
								{details?.basicDetails?.description || '--'}
							</Typography>
						</Stack>
					</Grid>

					<Grid item xs={6} sx={{ height: '80px' }}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Campaign Start/End Date
								{/* <span style={{ color: 'red' }}>*</span> */}
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{details?.scheduling?.startDate ? moment(details?.scheduling?.startDate).format('DD-MM-YYYY') : '--'}{' '}
								<Box component="span" sx={{ mx: 0.5 }} />
								{details?.scheduling?.endDate ? moment(details?.scheduling?.endDate).format('DD-MM-YYYY') : '--'}
							</Typography>
						</Stack>
					</Grid>

					<Grid item xs={6} sx={{ height: '80px' }}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Campaign Start/End Time
								{/* <span style={{ color: 'red' }}>*</span> */}
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{details?.scheduling?.startTime ? moment(details?.scheduling?.startTime, 'HH:mm').format('LT') : '--'} -{' '}
								{details?.scheduling?.endTime ? moment(details?.scheduling?.endTime, 'HH:mm').format('LT') : '--'}
							</Typography>
						</Stack>
					</Grid>

					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Max tries in a campaign
								{/* <span style={{ color: 'red' }}>*</span> */}
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{details?.scheduling?.maxTry || '--'}
							</Typography>
						</Stack>
					</Grid>
					{/* <Grid item xs={6}>
						<Stack>
							<InputLabel>Max tries in a day  <span style={{ color: "red" }}>*</span></InputLabel>
							<Typography variant="subtitle2">{details?.scheduling?.maxTryPerDay || '--'}</Typography>
						</Stack>
					</Grid> */}
					{/* <Grid item xs={6}>
						<Stack>
							<InputLabel>Auto call</InputLabel>
							<Typography variant="subtitle2">
								{details?.defaultSchedule ? (
									<IoIosCheckmarkCircle color={AppColors.TEXT_SUCCESS} size={20} />
								) : (
									<IoIosCloseCircle color={AppColors.DARK_GREY} size={20} />
								)}
							</Typography>
						</Stack>
					</Grid> */}
					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Total Users
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{details?.users?.length || details?.compaignUser?.length || 0}
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Conversation Type
								{/* <span style={{ color: 'red' }}>*</span> */}
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{assistantsInfo?.agentDetails?.agentName || assistantsInfo?.name  || '--'}
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Email subject
							</InputLabel>
							<Typography
								sx={{
									fontSize: '14px',
									fontWeight: 400,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								{details?.email?.subject || '--'}
							</Typography>
						</Stack>
					</Grid>
					{details?.advancedOptionsEnabled && (
						<>
							<Grid item xs={6}>
								<Stack>
									<InputLabel
										sx={{
											fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										Recurrence Schedule Days
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{details?.advancedOptions?.recurrence?.customDays || (details?.advancedOptions?.recurrence?.type && TYPE_TO_LABEL[details?.advancedOptions?.recurrence?.type]) || '--'}
									</Typography>
								</Stack>
							</Grid>
							{(details?.advancedOptions?.filters?.dateOfJoining?.after || details?.advancedOptions?.filters?.dateOfJoining?.before ) &&
							(<Grid item xs={6}>
								<Stack>
									<InputLabel
										sx={{
											fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										Filter Date Of Joining After/Before
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{details?.advancedOptions?.filters?.dateOfJoining?.after
											? moment(details.advancedOptions.filters.dateOfJoining.after).format('DD-MM-YYYY')
											: '--'}{' '}
										/{' '}
										{details?.advancedOptions?.filters?.dateOfJoining?.before
											? moment(details.advancedOptions.filters.dateOfJoining.before).format('DD-MM-YYYY')
											: '--'}
									</Typography>
								</Stack>
							</Grid>)}
							{(details?.advancedOptions?.filters?.dateOfRelieving?.after || details?.advancedOptions?.filters?.dateOfRelieving?.before) &&
							(<Grid item xs={6}>
								<Stack>
									<InputLabel
										sx={{
											fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										Filter Date Of Relieving After/Before
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{details?.advancedOptions?.filters?.dateOfRelieving?.after
											? moment(details.advancedOptions.filters.dateOfRelieving.after).format('DD-MM-YYYY')
											: '--'}{' '}
										/{' '}
										{details?.advancedOptions?.filters?.dateOfRelieving?.before
											? moment(details.advancedOptions.filters.dateOfRelieving.before).format('DD-MM-YYYY')
											: '--'}
									</Typography>
								</Stack>
							</Grid>)}

							{(details?.advancedOptions?.filters?.department  && details?.advancedOptions?.filters?.department?.value?.length > 0) &&
							<Grid item xs={6}>
								<Stack>
									<InputLabel
										sx={{
											fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										Filter Departments
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{(details?.advancedOptions?.filters?.department &&
											details?.advancedOptions?.filters?.department?.value?.join(', ')) ||
											'--'}
									</Typography>
								</Stack>
							</Grid>}

							{(details?.advancedOptions?.filters?.timezone && details?.advancedOptions?.filters?.timezone?.value?.length > 0) &&
							<Grid item xs={6}>
								<Stack>
									<InputLabel
										sx={{
											fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										Filter Timezones
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{(details?.advancedOptions?.filters?.timezone &&
											details?.advancedOptions?.filters?.timezone?.value?.join(', ')) ||
											'--'}
									</Typography>
								</Stack>
							</Grid> }

							{details?.advancedOptions?.filters?.source && (
								<Grid item xs={6}>
									<Stack>
										<InputLabel
											sx={{
												fontSize: '14px',
											fontWeight: 600,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
									  Filter Source
									</InputLabel>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: 400,
											lineHeight: '150%',
											color: AppColors.HEADING_TITLE4,
											fontFamily: 'Poppins',
										}}
									>
										{details?.advancedOptions?.filters?.source ? (details?.advancedOptions?.filters?.source?.value)?.toUpperCase() : '--'}
									</Typography>
								</Stack>
							</Grid>)}
						</>
					)}

					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Email body
							</InputLabel>
							<Box
								sx={{
									overflowX: 'auto',
									wordWrap: 'break-word',
									maxWidth: '100%',
									'& p': {
										fontSize: '14px',
										fontWeight: 400,
										lineHeight: '150%',
										color: AppColors.HEADING_TITLE4,
										fontFamily: 'Poppins',
									},
									'& img': {
										maxWidth: '100%',
										height: 'auto',
									},
								}}
							>
								<p dangerouslySetInnerHTML={{ __html: details?.email?.body }} />
							</Box>
						</Stack>
					</Grid>
					<Grid item xs={6}>
						<Stack>
							<InputLabel
								sx={{
									fontSize: '14px',
									fontWeight: 600,
									lineHeight: '150%',
									color: AppColors.HEADING_TITLE4,
									fontFamily: 'Poppins',
								}}
							>
								Email signature
							</InputLabel>
							<Box
								sx={{
									overflowX: 'auto',
									wordWrap: 'break-word',
									maxWidth: '100%',
									'& img': {
										maxWidth: '100%',
										height: 'auto',
									},
								}}
							>
								<p dangerouslySetInnerHTML={{ __html: details?.email?.signature }} />
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Card>
		</Box>
	);
}
